import { useContext, useEffect } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { Redirect } from "react-router-dom";
import userContext from "../../Context/userContext";
import "./Login.css";

//API's parameter
const STATUS_FORM = "StatusForm";

const Login = () => {
  const storage: string | null = localStorage.getItem(STATUS_FORM);
  const { onSuccess, onFailure, user } = useContext(userContext);
  const buttonValue = "Sign in with Google";

  const login = useGoogleLogin({
    onSuccess: onSuccess,
    onError: onFailure,
    prompt:"select_account",
    scope:"https://www.googleapis.com/auth/spreadsheets"
  });

  useEffect(() => {
    if (storage) {
      localStorage.removeItem(STATUS_FORM);
    }
  });

  return (
    <>
      <div className="HeaderLogin">
        <h2>Skill'Up</h2>
        <p className="catchLogin">
          Explore tes forces et axes d’apprentissage pour progresser vers ton
          objectif.
        </p>
      </div>
      <div className="login">
        <div className="googleLogin">
          <p className="googleWelcome">Bienvenue 👋🏻</p>
          <p className="googleP">
            Connecte toi pour accéder à l’outil d’auto évaluation
          </p>
          {!user ? (
            <button
              className="buttonSignIn"
              type="submit"
              value={buttonValue}
              onClick={() => login()}
            >
              {" "}
              Sign in with Google
            </button>
          ) : (
            <Redirect to="/tribu" />
          )}
        </div>
      </div>
    </>
  );
};

export default Login;
